import { Component, EventEmitter, Input, Output } from "@angular/core"
import { IProduct } from "graphql/queries/keyword.queries"

@Component({
  selector: 'contents-list',
  templateUrl: 'contents-list.component.html'
})

export class ContentsListComponent {
  @Input() contents: IProduct[]
  @Input() section: string
  @Input() contentSearch: string
  @Output() selectedContentOutput = new EventEmitter<IProduct>()

  sendSelectedContent(content: IProduct): void {
    this.contentSearch = content.name
    this.selectedContentOutput.emit(content)
  }

}
